import React from 'react';
import { Picky } from 'react-picky';
import 'react-picky/dist/picky.css';

interface Props {
  options: any;
  placeholder?: string;
  arrayValue: any;
  setArrayValue: Function;
  disabled?: boolean;
}

export const MultiSelectAll: React.FC<Props> = (props) => {
  const { options, placeholder, arrayValue, setArrayValue, disabled } = props;

  const selectMultipleOption = (value: any) => {
    setArrayValue(value);
  };

  return (
    <Picky
      placeholder={placeholder}
      value={arrayValue}
      options={options}
      onChange={selectMultipleOption}
      valueKey="id"
      labelKey="name"
      disabled={disabled}
      multiple={true}
      includeSelectAll={true}
      includeFilter={true}
      dropdownHeight={600}
      numberDisplayed={0}
    />
  );
};
